<template>
  <container-wrapper
    :designer="designer"
    :widget="widget"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    @click.stop="selectWidget(widget)"
    :class="{ selected: selected }"
  >
    <!-- 折叠组件 -->
    <div :key="widget.id" class="collapse-container" @click.stop="selectWidget(widget)">
      <van-collapse v-model="widget.options.expandName" :border="widget.options.border" :accordion="accordion">
        <van-collapse-item v-bind="item.options" v-for="(item, itemIdx) in widget.widgetList" :name="item.options.name" :key="itemIdx">
          <draggable
            :list="item.widgetList"
            item-key="id"
            v-bind="{ group: 'dragGroup', ghostClass: 'ghost', animation: 200 }"
            handle=".drag-handler"
            @add="evt => onContainerDragAdd(evt, item.widgetList)"
            @update="onContainerDragUpdate"
            :move="checkContainerMove"
            :component-data="{ inSubFormFlag: getSubFormFieldFlag() }"
          >
            <template #item="{ element: itemWidget, index: swIdx }">
              <transition-group name="fade" tag="div" class="form-widget-list" v-bind:key="swIdx">
                <template v-if="'container' === itemWidget.category">
                  <component
                    :is="itemWidget.type + '-widget'"
                    :widget="itemWidget"
                    :designer="designer"
                    :key="itemWidget.id"
                    :parent-list="item.widgetList"
                    :index-of-parent-list="swIdx"
                    :parent-widget="widget"
                  ></component>
                </template>
                <template v-else>
                  <component
                    :is="itemWidget.type + '-widget'"
                    :field="itemWidget"
                    :designer="designer"
                    :key="itemWidget.id"
                    :parent-list="item.widgetList"
                    :index-of-parent-list="swIdx"
                    :parent-widget="widget"
                    :design-state="true"
                  ></component>
                </template>
              </transition-group>
            </template>
          </draggable>
        </van-collapse-item>
      </van-collapse>
    </div>
  </container-wrapper>
</template>

<script>
import { toRefs, computed, watch, inject } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useContainer } from '@/components/form-designer/form-widget/container-widget/containerMixin';
import { useRef } from '@/components/form-render/refMixin';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import ContainerWrapper from '@/components/form-designer/form-widget/container-widget/container-wrapper';

export default {
  componentName: 'ContainerWidget',
  components: {
    ...FieldComponents,
    ContainerWrapper,
  },
  name: 'collapse-widget',
  props: {
    designer: Object,
    indexOfParentList: Number,
    parentList: Array,
    parentWidget: Object,
    widget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();
    const refMixin = useRef();
    const containerMixin = useContainer();

    const refList = inject('refList');

    const selected = computed(() => {
      return !!props.designer && props.widget.id === props.designer.selectedId;
    });

    const accordion = computed(() => {
      //手风琴模式accodition expandName是字符串，非手风琴模式是数组，需要根据设置自动改变
      //直接给组件的accodion属性赋值，expandName 来不及改变产生错误，因此加如这个计算属性，
      //反过来根据expandName变化来决定 accodion属性值
      return !Array.isArray(props.widget.options.expandName);
    });
    const customClass = computed(() => {
      return props.widget.options.customClass || '';
    });

    watch(
      () => props.widget.options.accordion,
      val => {
        //如果是手风琴模式，把数组转成字符串
        if (val) {
          props.widget.options.expandName = '';
        } else {
          props.widget.options.expandName = [];
        }
      }
    );

    /**
     * 检查接收哪些组件拖放，如不接受某些组件拖放，则根据组件类型判断后返回false
     * @param evt
     * @returns {boolean}
     */
    const checkContainerMove = evt => {
      return true;
    };

    /**
     * 设置折叠/打开状态
     * @param folded
     */
    const setFolded = folded => {
      props.widget.options.folded = !!folded;
    };

    refMixin.initRefList();

    return {
      i18nt,
      ...toRefs(props),
      ...containerMixin,

      accordion,
      checkContainerMove,
      selected,
    };
  },
};
</script>

<style lang="scss" scoped>
.collapse-container {
  margin: 0px;

  .form-widget-list {
    min-height: 28px;
  }
}

:deep(.el-card__header) {
  padding: 10px 12px;
}

.folded :deep(.el-card__body) {
  display: none;
}

.clear-fix:before,
.clear-fix:after {
  display: table;
  content: '';
}

.clear-fix:after {
  clear: both;
}

.float-right {
  float: right;
}
</style>
